import { fetchCurrentCommunity, fetchGuidelines } from 'src/modules/shared/context/actions';
import { fetchCommunityAbout } from 'src/modules/community/communityAbout/actions';
import WithErrorHandling, { RequestError } from 'src/components/hoc/withErrorHandling';
import { CommunityLayout } from 'src/components/layouts';
import MainContent from 'src/modules/community/communityAbout/components/mainContent';
import SideContent from 'src/modules/community/communityAbout/components/sideContent';
import { getCommunityAboutSeo } from 'src/utils/seo';
import { useSelector } from 'src/store/store';
import { PageContext } from 'src/constants/types';

function CommunityAboutPage() {
  const { currentCommunity } = useSelector(({ context }) => context);

  if (!currentCommunity) return null;

  return (
    <CommunityLayout
      currentPage="about"
      seo={getCommunityAboutSeo(currentCommunity)}
      sideBarContent={<SideContent />}
    >
      <MainContent />
    </CommunityLayout>
  );
}


CommunityAboutPage.getInitialProps = async ({ store: { dispatch, getState }, query: { communitySlug } }: PageContext) => {
  await dispatch(fetchCurrentCommunity(communitySlug));
  const state = getState();
  const { currentCommunity, communityErrorStatusCode, currentUser } = state.context;

  if (!currentCommunity) {
    const isHiddenPrivateCommunity = communityErrorStatusCode === 310;
    if (isHiddenPrivateCommunity) {
      if (!currentUser) throw new RequestError('This page is not available to visitors', 401);
      throw new RequestError('This is a private community', 404); // user is not a member
    }
    throw new RequestError('Error fetching community', communityErrorStatusCode);
  } else {
    await Promise.all([
      dispatch(fetchCommunityAbout(currentCommunity.slug)),
      dispatch(fetchGuidelines(currentCommunity.slug, currentCommunity.isPrivate)),
    ]);
  }

  return {};
};

export default WithErrorHandling(CommunityAboutPage);
